// ============================================================
// tx.io.js — 文件操作能力（打开/读取/下载）
// 只封装通用文件 API，不包含任何业务（模板/导入导出）逻辑；
// 模板相关逻辑见 tx.ioTemplate.js
// ============================================================

window.ttx = window.ttx || {};
window.ttx.io = {};

(function () {
    var ttx = window.ttx;

    /** 带登录态的请求头 */
    function authHeaders(extra) {
        var token = null;
        try { token = localStorage.getItem('token'); } catch (e) { token = null; }
        return Object.assign({}, extra || {}, token ? { Authorization: 'Bearer ' + token } : {});
    }

    /**
     * 保存二进制文件（浏览器下载）
     * @param {string} fileName 文件名
     * @param {Blob} blob 文件内容
     */
    ttx.io.saveBlob = function (fileName, blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }, 0);
    };

    /**
     * 保存文本文件
     * @param {string} fileName
     * @param {string} text
     * @param {string} [mime]
     */
    ttx.io.saveText = function (fileName, text, mime) {
        ttx.io.saveBlob(fileName, new Blob([text], { type: mime || 'text/plain;charset=utf-8;' }));
    };

    /**
     * 带登录态下载远程地址（如服务端生成的 Excel）
     * @param {string} url
     * @param {string} fileName
     * @param {Object} [options] fetch 配置（method/headers/body）
     * @returns {Promise<void>}
     */
    ttx.io.saveUrl = function (url, fileName, options) {
        var opts = Object.assign({}, options || {});
        opts.headers = authHeaders(opts.headers || {});
        return fetch(url, opts).then(function (res) {
            if (!res.ok) throw new Error('下载失败（' + res.status + '）');
            return res.blob();
        }).then(function (blob) {
            ttx.io.saveBlob(fileName, blob);
        });
    };

    /**
     * 打开文件选择框
     * @param {string|Function} accept 文件类型；或直接传回调
     * @param {Function} [callback] 选中文件回调 (file)
     */
    ttx.io.openFile = function (accept, callback) {
        var cb = typeof accept === 'function' ? accept : callback;
        var acceptTypes = typeof accept === 'string' ? accept : '';
        var input = document.createElement('input');
        input.type = 'file';
        if (acceptTypes) input.accept = acceptTypes;
        input.style.display = 'none';
        document.body.appendChild(input);
        input.addEventListener('change', function () {
            var file = input.files[0];
            document.body.removeChild(input);
            if (file && typeof cb === 'function') cb(file);
        });
        input.click();
    };

    /**
     * 读取文件文本
     * @param {File} file
     * @returns {Promise<string>}
     */
    ttx.io.readFileText = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () { resolve(String(reader.result || '')); };
            reader.onerror = function () { reject(new Error('文件读取失败')); };
            reader.readAsText(file, 'UTF-8');
        });
    };

})();
